/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".progress-container,.progress-overlay{position:fixed;top:0;left:0;width:100%;height:100%;z-index:99998;overflow:hidden}.progress-overlay{opacity:.7;background-color:#fff}.mat-progress-bar{z-index:99999;height:3px!important}"];
export { styles as styles };
